<template>
    <div class="land-dis-location">
        <div class="container" v-if="!isMobileChecker">
            <div class="dis-location-info-container">
                <div class="section-title" v-if="salesCard.district_loc_section_title != ''">
                    <h2>{{salesCard.district_loc_section_title}}</h2>
                </div>
                <div class="dis-location-map-container" :class="{'out-margin-none' : salesCard.district_loc_section_title == ''}">
                    <img :src="salesCard.district_loc_img" alt="">
                </div>
            </div>
        </div>
        <div class="land-dis-location-info-mobile" v-if="isMobileChecker">
            <div class="section-title-mobile">
                <div class="pic-title-bg" :style="'background-image: url(' + salesCard.district_loc_section_title_img + ')'"></div>
                <!-- <h2>{{salesCard.district_loc_section_title}}</h2> -->
                <h2 v-html="salesCard.district_loc_section_title"></h2>
            </div>
            <div class="land-dis-location-map-mobile">
                <img :src="salesCard.district_loc_img" alt="" id="sales-land-dis-mobile-map">
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-dis-location',
        components: {
        },
        data () {
            return {
                mobile: false,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            initPinchZoomer() {
                var _self = this;
                var image = new Image();
                image.onload = function () {
                    if ($(window).width() < 800) {
                        $("#sales-land-dis-mobile-map").pinchzoomer({
                            initZoom: 1.3,
                            minZoom: 1,
                            maxZoom: 5,
                        });
                    }
                }
                image.src = _self.salesCard.location_img;
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.initPinchZoomer();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-dis-location.scss';
    @import '@/styles/components/sales/respond/land-dis-loc-respond.scss';
    //  @import '@/styles/respond/sales/sales-land-partials/land-location-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>